// extracted by mini-css-extract-plugin
export default {"button":"headercart_button__93Pmy","icon":"headercart_icon__nSX7p","badge":"headercart_badge__bsi7g","bump":"headercart_bump__SmXre"};